<template>
<div class='vx-col w-full mt-4'>
    <vs-row w-full>
        <!-- cabecera {{ datos_tipo_juego_select }} -->
        <!-- datos_editar ==> {{ datos_editar }} -->
        <!-- <vs-col class="p-3 flex justify-end" v-if="datos.codigo != ''">
            <p class="mb-2">Código:</p> &nbsp; <h2 class=" "><b class="caja-codigo p-2"> {{ datos.codigo }} </b></h2>
        </vs-col> -->
        <vs-col class="p-3">
            <label for="nombre">Nombre del juego</label>
            <vs-input class="w-full" maxlength="300" size="default" placeholder="Nombre del juego" v-model="datos.nombre" />
        </vs-col>
        <vs-col class="m-3">
            <label for="descripcion">Descripción del juego</label>
            <vs-input class="w-full" maxlength="300" size="default" placeholder="Descripcion del juego" v-model="datos.descripcion" />
        </vs-col>
        <!-- <vs-col vs-w="6" class="p-3">
            <label for="tipo">Tipo de Juego</label>
            <v-select :options="listaTipos" :reduce="listaTipos => listaTipos" label="nombre" v-model="tipoSelect"></v-select>
            {{ tipoSelect }}
        </vs-col> -->
        <vs-col vs-w="6" class="p-3">
            <label for="subnivel">Subnivel</label>
            <v-select :options="arregloSubnivel" :reduce="arregloSubnivel => arregloSubnivel" label="nombre" v-model="subnivelSelect"></v-select>
        </vs-col>
        <vs-col vs-w="6" class="p-3">
            <label for="Area">Área</label>
            <v-select :options="areas" :reduce="areas => areas" label="nombrearea" v-model="areaSelect"></v-select>
        </vs-col>
        <vs-col vs-w="6" class="p-3">
            <label for="Puntaje">Puntaje</label>
            <vs-input class="w-full" size="default" placeholder="Puntaje del juego" v-model="datos.puntaje" />
        </vs-col>
        <vs-col vs-w="6" class="p-3">
            <label for="tiempo">Cronometro</label>
            <v-select id="tiempo" :options="tiempo" :reduce="tiempo => tiempo" label="nombre" v-model="tiempoSelect"></v-select>
            <!-- {{ tiempoSelect.id }} -->
        </vs-col>
        <vs-col vs-w="6" class="p-3 flex align-items-center">
            <vs-radio color="success" v-model="datos.estado" vs-value="1" class="mr-4" vs-name="layout-type-vertical">Activo</vs-radio>
            <vs-radio v-model="datos.estado" vs-value="0" class="mr-4" vs-name="layout-type-vertical">Inactivo</vs-radio>
        </vs-col>
        <vs-col vs-w="12" class="flex justify-end">
            <div class="m-2 w-1/2">
                <vs-button class="mt-4 w-full" icon="edit" :color="propiedades.btn_color" @click="f_guardar()"> {{propiedades.btn_txt}} </vs-button>
            </div>
            <!-- <div class="m-2 w-1/2">
                <vs-button class="mt-4 w-full" icon="undo" :color="propiedades.btn_color_cancel" v-if="btn_cancelar" @click="f_cancelar()"> {{propiedades.btn_txt_cancel}} </vs-button>
            </div> -->
        </vs-col>
    </vs-row>
</div>
</template>

<script>
import Vue from "vue";
import "vue-select/dist/vue-select.css";
import vSelect from "vue-select";
import GeneralMixin from '@/mixins/GeneralMixin';
Vue.component("v-select", vSelect);
export default {
    props: {
        datos_editar: {
            type: Object,
            default: function () {
                return {};
            },
        },
        tipo_accion: {
            type: Number,
            default: function () {
                return 0;
            },
        },
        btn_cancelar: {
            type: Boolean,
            default: function () {
                return false;
            },
        },
        datos_tipo_juego_select: {
            type: Object,
            default: function () {
                return {};
            },
        },
    },
    mixins: [GeneralMixin],
    components: {},
    data() {
        return {
            usuario: {},
            datos: {},
            arregloSubnivel: [],
            subnivelSelect: {},
            show_opciones: true,
            arregloOpciones: [],
            areas: [],
            areaSelect: {},
            datosJuego: [],
            opciones_juego: [],
            propiedades: {},
            mensaje: '',
            listaTipos: [],
            tipoSelect: {},
            tiempoSelect: {},
            tiempo: [{
                    id: 0,
                    nombre: 'No'
                },
                {
                    id: 1,
                    nombre: 'Si, agregar cronometro'
                }
            ],
            getCodigoStorage: false,
        };
    },
    created() {},
    mounted() {
        let me = this;
        me.getArea();
        me.getSubnivel();
        // me.f_get_tipos();
        me.f_inicio();
    },
    methods: {
        f_inicio() {
            let me = this;
            me.usuario = JSON.parse(localStorage.getItem('usuario'))[0];
            // console.log('cabecera juego', JSON.parse(localStorage.getItem('codigo')));
            me.id_editor = me.usuario.idusuario;
            me.id_grupo = me.usuario.id_group;
            me.datos = {
                id: 0,
                nombre: "",
                descripcion: "",
                puntaje: 10,
                estado: 1,
                codigo: "",
            }
            me.tiempoSelect = {
                id: 0,
                nombre: 'No'
            }
            me.subnivelSelect = {
                id: "",
                nombre: "",
            }
            me.areaSelect = {
                idarea: "",
                nombrearea: "",
            }
            me.tipoSelect = {
                id: me.datos_tipo_juego_select.id,
                nombre: me.datos_tipo_juego_select.nombre
            }
            me.show_opciones = true;
            me.propiedades.btn_txt = "Guardar";
            me.propiedades.btn_color = "primary"
            me.propiedades.btn_color_cancel = "dark"
            me.propiedades.btn_txt_cancel = "Cancelar"
            me.mensaje = 'Juego agregado con éxito'
            if (me.tipo_accion == 1) {
                me.show_opciones = false;
                me.propiedades.btn_txt = "Editar";
                me.propiedades.btn_color = "warning"
                me.datos = me.datos_editar;
                me.show_opciones = true;
                me.mensaje = 'Juego editado correctamente'
                me.getCodigoStorage = true;
            }
            me.f_verifica_juego_existe();
            setTimeout(() => {
                me.f_get_tiempo();
                me.f_if_editar_cabecera_Area();
                me.f_if_editar_cabecera_Subnivel();
            }, 1000);
        },
        f_verifica_juego_existe() {
            let me = this;
            //al crear el juego guardo el object en el storage, para recuperarlo sin salir del modal, y se borra cuando se crea un nuevo juego en al lista juegos
            let codeFromStorage = JSON.parse(localStorage.getItem('codigo'));
            if (codeFromStorage != null || codeFromStorage != undefined) {
                me.getCodigoStorage = true;
                me.datos = codeFromStorage;
            }
            // console.log('getCodigoStorage', me.getCodigoStorage, codeFromStorage)
        },
        f_get_tiempo() {
            let me = this;
            if (!me.getCodigoStorage) return
            let obj_tiempo = me.tiempo.find(objeto => objeto.id == me.datos.tiempo)
            // console.log('me.datos',this.datos, obj_tiempo)
            me.tiempoSelect = {
                id: me.datos.tiempo,
                nombre: obj_tiempo.nombre
            }
        },
        f_get_tipos() {
            let me = this;
            // me.$vs.loading();
            me.$http.get(this.$server_url + 'tiposGames')
                .then(function (response) {
                    // console.log(response.data);
                    me.listaTipos = response.data;
                    // me.$vs.loading.close();
                    // me.f_if_editar_Tipo();
                })
                .catch(function () {
                    me.f_notificaciones("No se obtuvo datos desde la DB", "danger");
                    // me.$vs.loading.close();
                })
        },
        f_guardar() {
            let me = this;
            // console.log(me.datos, me.subnivelSelect, me.areaSelect);
            if (me.datos.nombre == "") {
                me.f_notificaciones("Ingrese el nombre del juego", "danger")
                return;
            }
            if (me.datos.descripcion == "") {
                me.f_notificaciones("Ingrese la descripcion del juego", "danger")
                return;
            }
            if (me.subnivelSelect.id == "" || me.subnivelSelect.id == null) {
                me.f_notificaciones("Seleccione el subnivel", "danger")
                return;
            }
            if (me.areaSelect.idarea == "" || me.areaSelect.idarea == null) {
                me.f_notificaciones("Seleccione el area", "danger")
                return;
            }
            if (me.tipoSelect.id == "" || me.tipoSelect.id == null) {
                me.f_notificaciones("Seleccione el tipo de juego", "danger")
                return;
            }
            if (me.datos.puntaje == "") {
                me.f_notificaciones("Ingrese el puntaje del juego", "danger")
                return;
            }
            if (me.tiempoSelect.id == undefined || me.tiempoSelect.id == null) {
                me.f_notificaciones("Seleccione si desea agregar un cronómetro", "danger")
                return;
            }
            me.datos.id_subnivel = me.subnivelSelect.id;
            me.datos.id_area = me.areaSelect.idarea;
            me.datos.id_editor = me.id_editor;
            me.datos.id_grupo = me.id_grupo;
            me.datos.id_tipo = me.tipoSelect.id;
            me.datos.tiempo = me.tiempoSelect.id;
            me.$vs.loading();
            me.$http.post(this.$server_url + 'juegos', me.datos)
                .then(function (response) {
                    localStorage.setItem('codigo',JSON.stringify(response.data))
                    // console.log('cabecera juegos hu', response.data);
                    me.f_notificaciones(me.mensaje)
                    me.datos = response.data;
                    me.$emit('getCodigo', response.data)
                    me.$emit('get_listar_juegos', response.data)
                    // if (response.status == 201) {
                    // } else {
                    //     me.f_notificaciones("Error al agregar el juego")
                    // }
                    me.$vs.loading.close();
                })
                .catch(function () {
                    me.f_notificaciones(me.mensaje, "danger")
                    me.$vs.loading.close();
                })
        },
        getArea() {
            let me = this;
            me.$http.get(this.$server_url + 'area')
                .then(function (response) {
                    me.areas = response.data;
                    // console.log('get areas en cabecera', me.areas)
                    me.f_if_editar_cabecera_Area();
                })
                .catch(function () {})
        },
        getSubnivel() {
            let me = this;
            me.$http.get(this.$server_url + 'subnivel')
                .then(function (response) {
                    me.arregloSubnivel = response.data;
                    // console.log('getsubni', me.arregloSubnivel)
                    me.f_if_editar_cabecera_Subnivel();
                })
        },
        f_if_editar_cabecera_Area() {
            let me = this;
            if (!me.getCodigoStorage) return
            let obj_area = me.areas.find(objeto => objeto.idarea === me.datos.id_area)
            // console.log(me.tipo_accion, me.datos_editar)
            me.areaSelect = {
                idarea: me.datos.id_area,
                nombrearea: obj_area.nombrearea
            }
        },
        f_if_editar_cabecera_Subnivel() {
            let me = this;
            if (!me.getCodigoStorage) return
            let obj_subnivel = me.arregloSubnivel.find(objeto => objeto.id === me.datos.id_subnivel)
            me.subnivelSelect = {
                id: me.datos.id_subnivel,
                nombre: obj_subnivel.nombre
            }
        },
    },
};
</script>

<style scoped>
.caja-codigo {
    background-color: #f0b2b2;
    border-radius: 15px;

}
</style>
